
    export default {
    name: 'IconChangePassword',
    props: {
        width: {
            type: String,
            default: '22.640px'
        },
        height: {
            type: String,
            default: '22.673px'
        },
        color: {
            type: String,
            default: '#303030'
        }
    }
}
